import { Grid, LinearProgress, Typography } from "@mui/material";
import type { FC } from "react";
import { useCustomerWithId } from "../useCustomerWithId";

interface Props {
  readonly customerId: string;
}

interface ValueForTypeProps {
  readonly name: string;
  readonly value: number | string;
}

const ValueForType: FC<ValueForTypeProps> = ({ name, value }) => (
  <Grid container size={12}>
    <Grid size={6}>
      <Typography variant="subtitle2">{name}</Typography>
    </Grid>
    <Grid size={6}>
      <Typography variant="subtitle2">{value}</Typography>
    </Grid>
  </Grid>
);

const CustomerDetails: FC<Props> = ({ customerId }) => {
  const { customer, isLoading } = useCustomerWithId(customerId);
  if (isLoading) {
    return (
      <Grid container data-testid="customer-details">
        <Grid size={12}>
          <LinearProgress data-testid="loading-indicator" />
        </Grid>
      </Grid>
    );
  }
  if (!customer?.details) {
    return <Grid container data-testid="customer-details" />;
  }

  const amountOfGuarantee =
    customer.details.amountOfGuarantee !== undefined ? `${customer.details.amountOfGuarantee} PLN` : "";
  const income = customer.details.income !== undefined ? `${customer.details.income} PLN` : "";
  return (
    <Grid
      container
      data-testid="customer-details"
      sx={{
        rowGap: 2,
      }}
    >
      <ValueForType name="Zakres działalności" value={customer.details.scopeOfActivity ?? ""} />
      <ValueForType name="Wielkość gwarancji" value={amountOfGuarantee} />
      <ValueForType name="Przychód" value={income} />
    </Grid>
  );
};

export default CustomerDetails;
